<template>
  <div class="vuestic-modal">
    <transition name="modal" :duration="duration">
      <div v-if="show" class="modal-container">
        <div class="modal" @click.self="clickMask">
          <div class="modal-dialog" :class="modalClass_">
            <div class="modal-content">
              <!--Header-->
              <div class="modal-header" v-if="$slots.title || $slots.header">
                <slot name="header">
                  <div class="modal-title">
                    <slot name="title"></slot>
                  </div>
                </slot>
              </div>
              <!--Container-->
              <div class="modal-body">
                <slot></slot>
              </div>
              <!--Footer-->
              <div class="modal-footer">
                <slot name="footer">
                  <button type="button" :class="okClass" @click="ok" :disabled="okDisabled">
                    {{okText | translate}}
                  </button>
                  <button type="button" :class="cancelClass" @click="cancel" :disabled="cancelDisabled">
                    {{cancelText | translate}}
                  </button>
                </slot>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop"></div>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'vuestic-modal',
    props: {
      transition: {
        type: String,
        default: 'modal',
      },
      small: {
        type: Boolean,
        default: false,
      },
      large: {
        type: Boolean,
        default: false,
      },
      force: {
        type: Boolean,
        default: false,
      },
      okText: {
        type: String,
        default: 'modal.confirm',
      },
      cancelText: {
        type: String,
        default: 'modal.cancel',
      },
      okClass: {
        type: String,
        default: 'btn btn-primary',
      },
      cancelClass: {
        type: String,
        default: 'btn btn-secondary',
      },
      modalClass: {},
      okDisabled: {
        type: Boolean,
        default: false,
      },
      cancelDisabled: {
        type: Boolean,
        default: false,
      },
      autoDismiss: {
        type: Boolean,
        default: true,
      },
    },
    data () {
      return {
        show: false,
        duration: 500,
      };
    },
    computed: {
      modalClass_ () {
        return this.modalClass || {
          'modal-lg': this.large,
          'modal-sm': this.small,
        };
      },
    },
    created () {
      if (this.show) {
        document.body.className += ' modal-open';
      }
    },
    beforeDestroy () {
      document.body.className = document.body.className.replace(/\s?modal-open/, '');
    },
    watch: {
      show (value) {
        if (value) {
          document.body.className += ' modal-open';
        } else {
          window.setTimeout(() => {
            document.body.className = document.body.className.replace(/\s?modal-open/, '');
          }, this.duration);
        }
      },
    },
    methods: {
      listenKeyUp (event) {
        if (event.key === 'Escape') {
          this.cancel();
        }
      },
      ok () {
        this.$emit('ok', this);
        if (this.autoDismiss) {
          this.dismiss();
        }
      },
      cancel () {
        this.$emit('cancel', this);
        if (this.autoDismiss) {
          this.dismiss();
        }
      },
      clickMask () {
        if (!this.force) {
          this.cancel();
        }
      },
      open () {
        if (!this.show) {
          this.show = true;
          window.addEventListener('keyup', this.listenKeyUp);
        }
      },
      dismiss () {
        this.show = false;
        window.removeEventListener('keyup', this.listenKeyUp);
      },
    },
  };
</script>

<style lang="scss">
  @import "../../../sass/_variables.scss";
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";

  .vuestic-modal {
    height : 0;
    width  : 0;

    // For Transitioning
    .modal {
      display : block;
    }

    .modal-dialog, .modal-backdrop {
      transition : all .5s ease;
    }

    .modal-enter .modal-dialog, .modal-leave-active .modal-dialog {
      opacity   : 0;
      transform : translateY(-30%);
    }

    .modal-enter .modal-backdrop, .modal-leave-active .modal-backdrop {
      opacity : 0;
    }

    .modal-backdrop {
      opacity : 0.5;
    }

    //Modal styles

    .modal-header {
      height        : $modal-header-height;
      padding       : $modal-header-padding-y $modal-header-padding-x;
      border-bottom : $modal-header-border;
      font-size     : $font-size-larger;
      display       : flex;
      align-items   : center;
    }

    .modal-content {
      border-radius : $modal-content-border-radius;
    }

    .modal-footer {
      justify-content : center;
      padding         : 0 $modal-inner-padding;
      padding-bottom  : calc(#{$modal-inner-padding} - #{$modal-footer-btns-padding-bottom});
      flex-wrap       : wrap;
      .btn {
        margin : 0 $modal-footer-btns-margin-x $modal-footer-btns-padding-bottom $modal-footer-btns-margin-x;
      }
    }

    .modal-dialog {
      box-shadow : $modal-content-box-shadow-sm-up;
    }

    .model-fluid {
      max-width : inherit;
      margin    : .5rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-modal/VuesticModal.vue